import { type CookieOptions, useCookie } from "#app";
import { ref } from "#imports";
import type { FetchType } from "~/composables/filters/useFilters";

export const useCookieSessions = () => {
  const COOKIE_PREFIX = `ses`;
  // Local ref, NOT useState: a shared useState("cookies_type") key collided across all four cookie
  // composables (first initializer wins) and mis-namespaced this feature's cookies by nav order.
  const cookiesType = ref<FetchType>("sessions");

  function getCookieSession(name: string): any | null {
    const cookie = useCookie(`${cookiesType.value}_${COOKIE_PREFIX}_${name}`);

    if (cookie.value) {
      return cookie.value;
    }
    return null;
  }

  function setCookieDoneModal(show = true): void {
    const cookiesOpts: CookieOptions<any> & {
      readonly?: false | undefined;
    } = {
      expires: new Date(new Date().getDate() + 1),
      maxAge: 60 * 60 * 24,
      readonly: false, // Add the readonly property with a value of false
    };
    const currCookie = useCookie(`${cookiesType.value}_${COOKIE_PREFIX}_done_modal`, cookiesOpts);
    currCookie.value = show;
  }

  return {
    cookiesType,
    getCookieSession,
    setCookieDoneModal,
  };
};
